import { useMatchRoute } from './useMatchRoute';

export const useThreeSixtyNavigationItem = () => {
  const matchRoute = useMatchRoute();

  return {
    id: 'three-sixty',
    icon: 'ThreeSixty' as const,
    path: `${matchRoute}/freeze-frame-viewer`,
    label: '360',
  };
};
